var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Button"},[_c('router-link',{attrs:{"to":_vm.userData ? '/add-project' : '/register'}},[_vm._v(" Start your Project")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }